import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import VueRx from 'vue-rx';
import VueMoment from 'vue-moment';
import Vue2Filters from 'vue2-filters';
import store from './store';
import router from './router';
import App from './App.vue';
import axios from './plugins/axios';
import vuetify from './plugins/vuetify';
import utils from '@/mixins/utils';

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
sync(store, router);
Vue.use(VueRx);
Vue.use(VueMoment);
Vue.use(Vue2Filters);

Vue.mixin(utils);

axios.defaults.headers.common.Authorization = `Bearer ${store.state.auth.token}`;
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
